import { theme } from "@/core/theme";
import useDocTitle from "@/hooks/use-doc-title";

import ActiveDiscountsPanel from "./cmpHomeDashboard/ActiveDiscountsPanel";
import LatestOrdersPanel from "./cmpHomeDashboard/LatestOrdersPanel";
import { Masonry, MasonryItem, useColumnCount } from "./cmpHomeDashboard/Masonry";
import NewsPanel from "./cmpHomeDashboard/NewsPanel";
import OrdersPanel from "./cmpHomeDashboard/OrdersPanel";
import PatientsPanel from "./cmpHomeDashboard/PatientsPanel";
import ResultsToViewPanel from "./cmpHomeDashboard/ResultsToViewPanel";
import { dashboardPageMaxWidth, dashboardPagePx } from "./learningHub/dashboardLayout";

export default function CmpHomeDashboard() {
  useDocTitle("Dashboard", false, "Regenerus");
  const columnCount = useColumnCount();

  const panels = [
    <MasonryItem key="active-discounts">
      <ActiveDiscountsPanel />
    </MasonryItem>,
    <MasonryItem key="news">
      <NewsPanel />
    </MasonryItem>,
    <MasonryItem key="patients">
      <PatientsPanel />
    </MasonryItem>,
    <MasonryItem key="results">
      <ResultsToViewPanel />
    </MasonryItem>,
    <MasonryItem key="orders">
      <OrdersPanel />
    </MasonryItem>,
    <MasonryItem key="latest-orders">
      <LatestOrdersPanel />
    </MasonryItem>
  ];

  const mobilePanelOrder = [
    "active-discounts",
    "patients",
    "results",
    "orders",
    "latest-orders",
    "news"
  ];
  const twoColumnPanelOrder = [
    "active-discounts",
    "news",
    "results",
    "patients",
    "orders",
    "latest-orders"
  ];
  const orderedPanels =
    columnCount === 1
      ? mobilePanelOrder.map(key => panels.find(panel => panel.key === key))
      : columnCount === 2
      ? twoColumnPanelOrder.map(key => panels.find(panel => panel.key === key))
      : panels;

  return (
    <Masonry
      pt={48}
      pb={theme.spacing.section.pb}
      px={dashboardPagePx}
      maxWidth={dashboardPageMaxWidth}
      mx="auto"
    >
      {orderedPanels}
    </Masonry>
  );
}
